import { useQuery } from "@tanstack/react-query";

import useAuth from "@/hooks/stores/useAuth";
import { userService, authService } from "@/services";

export const userQueryKey = "profile";

export const useUser = () => {
  const { isAuthenticated, userId } = useAuth();
  return useQuery({
    queryKey: [userQueryKey, userId], // Include userId instead of just isAuthenticated
    queryFn: () => userService.getUser(userId),
    enabled: isAuthenticated && !!userId,
  });
};

export const useGetUserData = () => {
  const { isAuthenticated, userId } = useAuth();
  return useQuery({
    queryKey: ['user', userId], // Include userId instead of just isAuthenticated
    queryFn: () => userService.getUserData(userId),
    enabled: isAuthenticated && !!userId,
  });
};

// New hook for getting current user profile
export const useUserProfile = (options = {}) => {
  const { isAuthenticated, userId } = useAuth();
  return useQuery({
    queryKey: ['userProfile', userId], // Include userId instead of just isAuthenticated
    queryFn: () => authService.getProfile(),
    enabled: isAuthenticated && !!userId,
    staleTime: 5 * 60 * 1000, // 5 minutes
    retry: 2,
    ...options // Allow overriding default options
  });
};
